/* eslint-disable no-mixed-spaces-and-tabs */
/* eslint-disable max-len */
/* eslint-disable max-lines */
import { PromotionalSkuData } from '../types';


export type PromotionalDataCallback = () => Record<string, PromotionalSkuData>;

export interface PromotionOptions {
  callback?: PromotionalDataCallback;
}

export class PromotionalItemData {
  private static instance: PromotionalItemData;
  private data: Record<string, PromotionalSkuData> = {};
  private callback: PromotionalDataCallback | null = null;

  constructor (options?: PromotionOptions) {
  	if (options?.callback) {
  		this.callback = options.callback;
  		this.loadData();
  	}
  }

  static getInstance (options?: PromotionOptions): PromotionalItemData {
  	if (!PromotionalItemData.instance) {
  		PromotionalItemData.instance = new PromotionalItemData(options);
  	}
  	return PromotionalItemData.instance;
  }

  /**
   * Set the callback function that provides the accessories data
   */
  static setCallback (callback: PromotionalDataCallback): void {
  	PromotionalItemData.getInstance().callback = callback;
  	PromotionalItemData.getInstance().loadData();
  }

  /**
   * Get all accessories data
   */
  static getData (): Record<string, PromotionalSkuData> {
  	return PromotionalItemData.getInstance().data;
  }

  /**
   * Get accessory data by SKU
   */
  static findBySku (sku: string): PromotionalSkuData | null {
  	return PromotionalItemData.getInstance().data[sku] || null;
  }

  /**
   * Get accessory data by ID
   */
  static findById (id: string): PromotionalSkuData | null {
  	const instance = PromotionalItemData.getInstance();
  	return Object.values(instance.data).find((component) => component.id === id) || null;
  }

  /**
   * Get all SKUs
   */
  static getAllSkus (): string[] {
  	return Object.keys(PromotionalItemData.getInstance().data);
  }

  /**
   * Add or update an accessory
   */
  static addAccessory (sku: string, componentData: PromotionalSkuData): void {
  	PromotionalItemData.getInstance().data[sku] = componentData;
  }

  /**
   * Remove an accessory
   */
  static removeAccessory (sku: string): boolean {
  	const instance = PromotionalItemData.getInstance();
  	if (instance.data[sku]) {
  		delete instance.data[sku];
  		return true;
  	}
  	return false;
  }

  /**
   * Load data using the registered callback
   */
  private loadData (): void {
  	if (this.callback) {
  		const rawData = this.callback();
  		// Ensure priceAdjustment is a number (API might return strings)
  		this.data = Object.fromEntries(
  			Object.entries(rawData).map(([sku, item]) => [
  				sku,
  				{ ...item, priceAdjustment: Number(item.priceAdjustment) || 0 }
  			])
  		);
  	}
  }

  /**
   * Reload data
   */
  static reload (): void {
  	PromotionalItemData.getInstance().loadData();
  }

  /**
   * Clear all data
   */
  static clear (): void {
  	PromotionalItemData.getInstance().data = {};
  }
}
